// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedJoystick_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M8.16016 4.15918L9.57437 2.74497L11.001 4.17157L10.997 0H12.997L13.0009 4.08093L13.001 4.17152L14.4176 2.75497L15.8318 4.16918L12.001 8L8.16016 4.15918ZM7 8.00077C7 7.39294 7.16947 6.81677 7.47268 6.30085L9.01367 7.84184C9.00452 7.89727 9 7.95047 9 8.00077H7ZM16.5281 6.30215L14.9866 7.84361C14.9956 7.8984 15 7.951 15 8.00077C15.0001 13.285 14.5554 16.8634 13.2287 22.0008H10.7713C9.44465 16.8634 9 13.285 9 8.00077H7C7 13.2858 7.43798 16.9645 8.70728 22.0008H4V24.0008L9.23172 24.0008H10H14H14.7683L20 24.0008V22.0008H15.2927C16.562 16.9645 17.0001 13.2858 17 8.00077C17 7.39345 16.8308 6.81773 16.5281 6.30215Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedJoystick is a generated icon component.
 */
let IconMedJoystick = IconMedJoystick_1 = class IconMedJoystick extends IconBaseElement {
    render() {
        return html `${IconMedJoystick_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedJoystick.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedJoystick = IconMedJoystick_1 = __decorate([
    customElement('zui-icon-med-joystick')
], IconMedJoystick);
export { IconMedJoystick };
